// @givmo/passkeys — "6-digit", "24-hour" and "Sign-in" never break at their hyphen (a line otherwise
// ends on "a new 6-" with "digit" below it, or on "Sign-" with "in & security." below it, as the design
// rounds found), and "24 hours" never at its space (the approved B2d-lost frame keeps it whole).
// Presentation only: the words, and the text a reader or a test reads, are unchanged.

import { Fragment, type ReactNode } from 'react';

const WHOLE = /(\d+-(?:digit|hour)|\d+ hours?|[Ss]ign-in)/g;

/** The line with each "N-digit" / "N-hour" / "N hours" / "Sign-in" wrapped so it cannot break. */
export function keepNumbersWhole(line: string): ReactNode {
  const parts = line.split(WHOLE);
  if (parts.length === 1) return line;
  return parts.map((part, index) =>
    index % 2 === 1 ? (
      <span key={index} className="whitespace-nowrap">
        {part}
      </span>
    ) : (
      <Fragment key={index}>{part}</Fragment>
    ),
  );
}
